// extracted by mini-css-extract-plugin
export var createdDate = "_h9-1";
export var divider = "_h9-2";
export var headerDivider = "_h9-3";
export var messagesCard = "_h9-0";
export var messagesContainer = "_h9-6";
export var messagesContainerWrapper = "_h9-4";
export var showLeftPanelButton = "_h9-8";
export var topButtons = "_h9-7";
export var withPadding = "_h9-5";